// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sync-select-groups__heading[data-v-32b50e04]{max-width:733px;margin:0 auto}.flow-groups-container[data-v-32b50e04]{max-height:272px;margin:30px auto}", ""]);
// Exports
module.exports = exports;
